"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Button_1 = __importDefault(require("../ui-components/Button"));
var Table_1 = __importDefault(require("../table/Table"));
var List = function (_a) {
    var clients = _a.clients, onRevokeButtonClick = _a.onRevokeButtonClick;
    var model = [{
            header: 'Client name',
            accessor: 'name'
        }, {
            header: 'Client Id',
            accessor: 'client_id'
        }, {
            header: 'Created at',
            accessor: 'created_at',
        }, {
            header: 'Revoke client',
            accessor: 'delete'
        }];
    var rows = clients.map(function (client) { return ({
        name: client.name,
        client_id: client.clientId,
        created_at: client.createdAt,
        delete: preact_1.h(Button_1.default, { onClick: function () { return onRevokeButtonClick(client); }, danger: true }, "x")
    }); });
    return preact_1.h(Table_1.default, { model: model, rows: rows });
};
exports.default = List;
